import { CommissionType } from '@/@types/PartnerProgram';
import { toast } from '@/hooks/use-toast';
import { PartnerProgramService } from '@/services/partner-program.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export function useUpdatePartnerCommission(productId: string) {
  const { t } = useTranslation(['affiliates', 'common']);
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      partnerId,
      data,
    }: {
      partnerId: string;
      data: {
        commission_type: CommissionType;
        commission_value: number;
        commission_currency: string;
      };
    }) => PartnerProgramService.updatePartnerCommission(productId, partnerId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['partner-program-partners', productId],
      });
      toast({
        variant: 'success',
        description: t('affiliates:partner_commission_saved', 'Comissão configurada com sucesso!'),
      });
    },
    onError: () => {
      toast({
        variant: 'error',
        description: t('common:data_submission_error'),
      });
    },
  });

  return {
    updatePartnerCommission: mutateAsync,
    isUpdating: isPending,
  };
}
